<template>
  <div id="centerLeftBottom">
    <div class="bg-color-black">
      <div class="d-flex title-box">
        <!-- <span>
                    <icon name="align-left" class="text-icon"></icon>
                </span> -->
        <el-tooltip 
          effect="dark" 
          placement="bottom-start" 
          popper-class="hospital-list-tooltip"
          :disabled="!bigSkuCustomerList.length"
        >
          <div slot="content" class="hospital-tooltip-content">
            <div class="tooltip-title">医院列表</div>
            <div class="hospital-list">
              <div 
                v-for="hospital in bigSkuCustomerList" 
                :key="hospital.customerId"
                class="hospital-item  cursor-pointer"
                 @click="goCustomer(hospital)"
              >
                {{ hospital.customerName }}
              </div>
            </div>
          </div>
          <span class="fs-xl text_title commonTitle hospital-title cursor-pointer">客户一览表</span>
        </el-tooltip>
      </div>
      <div class="d-flex flex-column body-box">
        <ul class="ul_item d-flex flex-column">
          <li class="d-flex jc-between f14 commonText cursor-pointer header-item">
            <span>医院名称</span>
            <span>床位数</span>
            <span>医护人员</span>
          </li>
          <div class="scrollable-content">
            <li
              v-for="customer in customerList"
              :key="customer.customerId"
              class="d-flex jc-between f14 commonText"
            >
              <span class="customer-name">{{ customer.customerName }}</span>
              <span
                ><span class="text-info-1 fs-xl">{{ customer.beds }}</span
                ></span
              >
              <span
                ><span class="text-info-1 fs-xl">{{ customer.numMember }}</span
                ></span
              >
            </li>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "@/api/index";
export default {
  data() {
    return {
      params: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        customerId: "",
      },
      customerList: [], // 瀹㈡埛鍒楄〃鏁版嵁
      bigSkuCustomerList: [], // 澶у鎴峰垪琛ㄦ暟鎹紝鐢ㄤ簬hover鏄剧ず
      intervalId: null, // 鐢ㄤ簬瀛樺偍瀹氭椂鍣ㄧ殑 ID
    };
  },
  // components: { centerRight2Chart1 }
  mounted() {
    this.params.customerId = this.$route.query.customerId;
    console.log(this.$route.query);
    this.getData();
    this.getBigSkuCustomer();

    // 每 30 分钟刷新一次数据
    this.intervalId = setInterval(() => {
      this.getData();
    }, 30 * 60 * 1000);
  },
  beforeDestroy() {
    // 组件销毁前清理定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    goCustomer(item) {
      window.open(
        window.location.origin +
          "/#/index?customerId=" +
          item.customerId +
          "&customerName=" +
          item.customerName,
        "_blank"
      );
    },
    async getData() {
      const res = await api.getSkuCustomerList(this.params);
      if (res.ResultCode == 0) {
        this.customerList = res.Result || [];
      }
    },
    async getBigSkuCustomer() {
      const res = await api.getBigSkuCustomer({});
      if (res.ResultCode === 0) {
        // debugger
        this.bigSkuCustomerList = res.Result || [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#centerLeftBottom {
  //$box-height: 410px;
  //$box-width: 500px;
  //padding: 0 16px;
  // height: $box-height;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  .text_title {
    padding-top: 0.5rem;
  }
  
  .hospital-title {
    cursor: pointer;
    transition: color 0.3s ease;
    
    &:hover {
      color: #409EFF;
    }
  }
  
  .ul_item {
    li {
      padding: 10px;

      span {
        flex: 1;
        text-align: center;
      }

      span:nth-child(1) {
        text-align: left;
      }
    }
    
    .header-item {
      position: sticky;
      top: 0;
      background: inherit;
      z-index: 1;
    }
    
    .scrollable-content {
      max-height: calc(100% - 50px);
      overflow-y: auto;
      
      &::-webkit-scrollbar {
        width: 6px;
      }
      
      &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
      }
      
      &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.3);
        border-radius: 3px;
        
        &:hover {
          background: rgba(255, 255, 255, 0.5);
        }
      }
    }
    
    .customer-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 150px;
      display: inline-block;
    }
  }

  .bg-color-black {
    // padding: 5px;
    height: 100%;
    // width: $box-width;
    border-radius: 10px;
    padding: 0 20px;
  }
  .title-box {
    height: 12%;
    padding: 0px 8px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .body-box {
    // border-radius: 10px;
    // overflow: hidden;
    //margin-top: 15px;
    height: 80%;
    .dv-cap-chart {
      width: 100%;
      height: 160px;
    }
  }
  .f14 {
    font-size: 14px;
  }
}
</style>

<style lang="scss">
.hospital-list-tooltip {
  max-width: 400px !important;
  
  .hospital-tooltip-content {
    .tooltip-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
      color: #fff;
      border-bottom: 1px solid #666;
      padding-bottom: 5px;
    }
    
    .hospital-list {
      max-height: 300px;
      overflow-y: auto;
      
      .hospital-item {
        padding: 5px 0;
        color: #fff;
        font-size: 14px;
        line-height: 1.4;
        border-bottom: 1px solid #444;
        
        &:last-child {
          border-bottom: none;
        }
        
        &:hover {
          color: #409EFF;
        }
      }
    }
  }
}
</style>

